export default __webpack_public_path__ + "assets/img_motorhome-f7cc00f7.png";